/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Batch_Error_ToastInputs */

const es_admin_billing_batch_error_toast = /** @type {(inputs: Admin_Billing_Batch_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al actualizar la factura`)
};

const en_admin_billing_batch_error_toast = /** @type {(inputs: Admin_Billing_Batch_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update invoice`)
};

/**
* | output |
* | --- |
* | "Failed to update invoice" |
*
* @param {Admin_Billing_Batch_Error_ToastInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_batch_error_toast = /** @type {((inputs?: Admin_Billing_Batch_Error_ToastInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Batch_Error_ToastInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_batch_error_toast(inputs)
	return en_admin_billing_batch_error_toast(inputs)
});
export { admin_billing_batch_error_toast as "admin.billing.batch.error_toast" }